import { useEffect } from 'react'

export default (callable) => useEffect(callable, [])
